<template>
  <div class="wrap agreement">
    <h1>上海大智慧信息科技有限公司非投资咨询类软件产品许可使用合同</h1>
    <p>
      甲方：
      <span>{{userName}}</span>
    </p>
    <p>
      乙方：
      <span>上海大智慧信息科技有限公司</span>
    </p>
    <p
      class="indent"
    >欢迎您购买大智慧软件产品，上海大智慧信息科技有限公司将竭诚为您提供更全面、更优质的服务。本协议适用于上海大智慧信息科技有限公司销售的全部非投资咨询类软件产品（本产品不包含投资顾问服务）。在您购买之前，请先仔细阅读本协议的条款。您在购买程序过程中点击“我同意协议”按钮即表示您与上海大智慧信息科技有限公司达成协议，视为您已了解并完全接受本协议项下的全部条款。</p>
    <h2>一、协议的完善和修改</h2>
    <p
      class="indent"
    >乙方将不时根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改本协议的条款，甲方确认乙方无需就协议条款的修改事宜逐一通知甲方。甲方继续使用乙方软件产品的，视为甲方接受修改后的协议条款，乙方与甲方之间的权利以及义务约定，均以最新修改后的协议条款为准。</p>
    <h2>二、注册信息和隐私保护</h2>
    <p
      class="indent"
    >1.甲方完成注册申请手续后，获得帐号的使用权，帐号的所有权归乙方所有。甲方应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽、准确的要求。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，乙方不负任何责任。</p>
    <p
      class="indent"
    >2.甲方不应将其帐号、密码转让或出借予他人使用。如甲方发现其帐号遭他人非法使用，应立即通知乙方。因黑客行为或甲方的保管疏忽导致帐号、密码遭他人非法使用，乙方不承担任何责任。</p>
    <p
      class="indent"
    >3.甲方的登陆名和密码只能供甲方本人使用，不得以任何形式转让或授权他人使用，如果发现同一帐号和密码在同一时间内被多人同时登陆使用，乙方有权取消此帐号的甲方资格，并不予任何赔偿或者退还任何已缴纳的服务费用。</p>
    <dl>
      <dt class="indent">4.乙方不对外公开或向第三方提供甲方的注册资料，除非：</dt>
      <dd class="indent">（1）事先获得甲方的明确授权；</dd>
      <dd class="indent">（2）只有透露甲方的个人资料，才能提供甲方所要求的产品和服务；</dd>
      <dd class="indent">（3）根据有关的法律法规要求；</dd>
      <dd class="indent">（4）按照相关政府主管部门的要求。</dd>
    </dl>
    <h2>三、服务内容及期限</h2>
    <p class="indent">1.甲方向乙方支付软件产品服务费用，乙方根据甲方需求，提供软件产品服务。</p>
    <p
      class="indent"
    >2.服务期限：自软件帐号激活之日起计算。如甲方购买的产品未及时激活，乙方产品已下架，甲方同意以其他类似产品替代，如甲方选择产品高于原产品价格，甲方应补齐差价。</p>
    <h2>四、服务费用及续费</h2>
    <p class="indent">1.软件产品服务费用按照购买日公布的价格及优惠政策执行。产品费用价格为含税价格。</p>
    <p class="indent">2.本合同签署后五个工作日内，甲方须向乙方支付全部服务费用，乙方收到全部服务费用后十个工作日内向甲方开具符合国家税务要求的相应金额发票。</p>
    <p
      class="indent"
    >3.若甲方拟于本协议期满后继续按照本协议约定条件接受乙方服务的，甲方应于本协议期满前十五个工作日内向乙方支付相应软件产品的下期服务费用，则本协议有效期自动顺延。</p>
    <p class="indent">4.本协议有效期顺延的，顺延次数不限。顺延期间乙方服务费用发生变更的，顺延期限届满后双方按变更后的服务费用履行。</p>
    <h2>五、甲方权利和义务</h2>
    <h3>（一）甲方权利</h3>
    <p class="indent">1.甲方可以登录一个终端使用软件产品，享有通过软件产品获取服务的权利。</p>
    <p class="indent">2.甲方有权要求乙方通过电话解答方式提供软件产品的操作技术培训和使用指导。</p>
    <p class="indent">3.甲方有权要求乙方按照本合同约定及时提供软件产品服务和产品升级服务。</p>
    <p class="indent">4.甲方在接受服务过程中发现产品不能正常使用的情形，可以要求乙方通过电话和远程维护方式给予指导和帮助。</p>
    <p
      class="indent"
    >5.甲方应按照本协议约定的时间和金额及时向乙方支付服务费用。甲方可通过上门支付、网上转帐、邮局汇款或其他有效的付款方式向乙方收款帐户支付服务费；甲方上门支付，仅限于向乙方的财务工作人员交付款项并索取法定付款凭证。除前述情形外，乙方不存在其他收款途径，乙方禁止员工以个人名义向甲方收取服务费用，甲方自行向以个人名义开户的银行账户或其他账户或乙方非财务工作人员付款的行为等均与乙方无关。</p>
    <p class="indent">6.本协议终止后，甲方不再享有乙方提供的本合同约定的收费服务的权利，但可以继续享有乙方提供的免费版软件产品服务权利。</p>
    <h3>（二）甲方义务</h3>
    <p
      class="indent"
    >1.甲方通过登录乙方指定网站下载软件产品，自行设定帐号和密码，甲方应妥善保护登录帐号和密码的安全，不得将帐号、密码泄露、转让或出借他人。若甲方保管疏忽导致帐号、密码不能正常使用或遭他人非法使用，所致损失由甲方承担，同时甲方应及时通知乙方并采取有效措施，避免损失进一步扩大。若帐号密码遗失，甲方应向乙方提供签字的身份证/支付凭证及其他相关材料复印件，经乙方核实身份后，可为甲方重置初始密码，甲方应及时予以修改。如因甲方原因不能提供上述证明材料的，甲方承担相关责任。</p>
    <p class="indent">2.甲方提供软件产品安装、运行必须的场地、软硬件（包括计算机及操作系统）、电源、互联网接入，以及相关资源，以保证软件安装、运行的正常进行。</p>
    <p class="indent">3.服务期内，乙方持续、不间断地向甲方提供服务，同时甲方持续、不间断地接受乙方服务，甲方不得暂停接受服务。</p>
    <p
      class="indent"
    >4.甲方应尊重乙方软件产品的著作权及其他知识产权，未经乙方的书面同意，甲方不对软件产品进行复制、修改、发行、出租、出借、翻译、传播，不进行反汇编、反编译；违反本条内容情节严重者乙方可追究法律责任。</p>
    <p
      class="indent"
    >5.甲方保证本软件产品服务仅限甲方本人（或本单位）自行使用，不擅自改变产品使用用途，如引用本产品的相关信息，应取得乙方同意并完整引用产品信息，注明信息来源及“未经大智慧许可，不得转载”字样。</p>
    <p
      class="indent"
    >6.本合同有效期内，甲方承诺未直接或间接从事与乙方有竞争关系的业务，并不以任何方式将乙方产品提供给第三方进行研究、修改、复制、开发衍生产品或以其他方式使用，或发生其他因甲方行为致使该第三方存在侵害或潜在侵害乙方权益的事实和行为。如甲方违反本约定，乙方有权立即停止提供服务，并追究甲方相应违约责任，甲方所付款项不予退回。</p>
    <h2>六、乙方权利和义务</h2>
    <h3>（一）乙方权利</h3>
    <p class="indent">1.本协议项下软件产品及服务由乙方设计开发，与之相关的全部著作权、商标权、专利权等知识产权和商业秘密归乙方所有。</p>
    <p class="indent">2.乙方有权要求甲方按照本合同约定及时全额支付服务费，乙方收到服务费用后应及时向甲方提供软件产品服务。</p>
    <p class="indent">3.乙方可以在甲方同意的前提下，通过软件、电子邮件、手机短信或其他方式向甲方发送各种产品信息。</p>
    <h3>（二）乙方义务</h3>
    <p class="indent">1.乙方收到甲方支付的本合同约定服务费用后向甲方提供软件产品服务。</p>
    <p class="indent">2.乙方负责向甲方提供规定的标准大智慧信息服务，保证其所提供的服务均符合国家有关法律法规的相关规定。</p>
    <p class="indent">3.针对交易所的一般性数据结构调整，乙方在交易所推出新产品或新规则之前，将及时进行相应调整。</p>
    <p
      class="indent"
    >4.乙方向甲方提供软件产品的操作培训和使用指导。在甲方遇到与乙方产品相关的技术问题时，乙方应迅速做出反应，采取电话、远程直接操作维护方式协助甲方及时解决问题。</p>
    <p class="indent">5.合同有效期内，乙方及时为甲方提供软件产品的升级和维护服务。</p>
    <p class="indent">
      6.乙方联系地址：上海市浦东杨高南路428号1号楼
      <br />联系电话：021-20219988 投诉电话：021-20219952
      <br />甲方如发现乙方工作人员与甲方私下联系，可投诉举报。
    </p>
    <h3>（三）乙方禁止性行为</h3>
    <p class="indent">1.接受甲方委托从事证券投资、代甲方作出投资决策。</p>
    <p class="indent">2 以任何方式向甲方承诺或者保证投资收益。</p>
    <p class="indent">3.与甲方约定分享投资收益或者分担投资损失。</p>
    <p class="indent">4.以虚假信息、市场传言或者内幕信息为依据向甲方提供投资分析、预测或建议。</p>
    <p class="indent">5.为乙方及其关联方的利益损害甲方利益，为特定客户利益损害甲方利益。</p>
    <p class="indent">6.无证券投资咨询业务资格的情况下提供证券投资咨询服务。</p>
    <p class="indent">7.以个人名义向甲方收取服务费用。</p>
    <p class="indent">8.法律、法规、规章所禁止的其他证券欺诈行为。</p>
    <h2>七、免责条款</h2>
    <p class="indent">
      <b>1.在服务期内，乙方将有权根据经营活动的需要，随时对软件产品的服务内容进行更新、增加或删除，且无需另行通知或取得甲方的同意。</b>
    </p>
    <p class="indent">
      <b>2.若乙方在软件产品中提供快捷键方式供甲方调用第三方供应商的委托交易程序，因该委托交易程序的运行维护由第三方供应商负责，故由于委托交易程序故障导致的任何交易安全问题，亦由第三方供应商负责，与乙方无关。</b>
    </p>
    <p class="indent">
      <b>3.乙方努力为甲方提供丰富的信息服务，但相关信息仅供甲方参考，不作为甲方及甲方客户或任何接触该等信息的第三方投资人操作的决策依据。乙方不对前述人士依据乙方的信息所做投资引致的任何风险、盈亏等负责。</b>
    </p>
    <p class="indent">
      <b>4.任何情形下，乙方及其代理人、工作人员的任何口头、书面承诺都不视为乙方对甲方或任何接触该等信息的第三方具体操作和投资收益的承诺/建议，据此操作风险自担。乙方不对甲方及前述第三方根据乙方信息及乙方代理人、工作人员的任何口头、书面承诺所做投资引致的任何风险、盈亏等承担任何责任。</b>
    </p>
    <p class="indent">
      <b>5.乙方尽力提供完整、及时、准确的信息，全力保障信息的优质传输，但鉴于信息传输及交易程序可能遭受系统故障、信息源异常、卫星传输线路故障、通讯线路故障、网络故障、黑客攻击、病毒侵入、电力的中断或故障、他人蓄意破坏、技术发展限制、法律法规变更、政府禁令、监管机构要求等及不可抗力事件影响，乙方不对由此造成的数据中断、延迟、丢失、错误、遗漏等信息异常或信息传递异常所致后果负责，不对交易异常引致的盈利或亏损以及其他情形负责。</b>
    </p>
    <h2>八、保密条款</h2>
    <p
      class="indent"
    >1.双方同意，任何一方不得向任何第三方披露本协议的任何条款和内容，采用至少与其对于自身专有资料相同的谨慎与防范措施，对本协议或因履行本协议涉及的任何商业秘密或专有信息予以保密。未经对方书面许可，不得复制、向他人透露或者使用该等资料或数据。</p>
    <p class="indent">2.双方的保密义务不因本协议的修改、无效、变更、撤销、解除而终止。</p>
    <h2>九、违约责任</h2>
    <p class="indent">1.任何一方未履行本协议项下的任何一个条款均被视为违约，违约方应自行承担因自己的违约行为造成的不利后果。</p>
    <p
      class="indent"
    >2.任何一方在收到对方要求纠正的书面通知后，应在二十日内对违约行为予以纠正并书面通知对方，如认为违约行为不存在，则应在二十日内向对方提出书面异议或说明，在此情况下，双方可以就此问题进行协商，协商不成的，按本协议争议解决条款解决。</p>
    <p class="indent">3.如甲方购买的产品未及时激活，在激活时遇该产品已下架的，乙方提供其他类似产品作为替代，不视为乙方违约。</p>
    <h2>十、争议解决</h2>
    <p class="indent">
      <b>1.凡因本协议引起的或与本协议有关的任何争议，由双方本着友好合作、平等互利的原则协商解决，协商不成的，任何一方均可提交上海仲裁委员会，由该会按照申请仲裁时现行有效的仲裁规则进行仲裁。仲裁结果是终局的，对双方均具有法律约束力。</b>
    </p>
    <p class="indent">2.在争议的处理过程中，除正在进行仲裁的条款外，不影响其他条款的效力，其他条款能够继续履行的，仍继续履行。</p>
    <h2>十一、产品风险提示</h2>
    <p class="indent">
      <b>1.甲方应充分认识到证券投资的风险，乙方所提供的所有数据与信息，仅供参考使用，甲方不应将其视作乙方明示、默示地承诺投资收益，不应将其视为具体投资品种选择/买卖时机的建议，不应将其视为对证券市场/投资品种的走势、投资品种的可行性的分析、预测或建议，或任何其他形式的投资咨询/建议，甲方据此操作，风险自担。</b>
    </p>
    <p class="indent">
      <b>2.乙方通过软件产品为甲方提供财经金融资讯和行情数据信息，并通过相关数据分析系统、统计运算模型对上述资讯和数据进行整理、加工和集成，为甲方提供高附加值的信息和数据服务，（该等信息及数据服务均是根据数据模型自动生成，不存在人为的操控或操纵），以利于甲方在投资过程中理性决策、控制风险。乙方对甲方的投资决策可能带来的风险或损失不承担任何违约、赔偿或其他民事责任。</b>
    </p>
    <h2>十二、知识产权</h2>
    <p class="indent">乙方尊重他人知识产权和合法权益。若您认为您的知识产权或其他合法权益被侵犯，请按照以下说明向乙方提供资料∶</p>
    <p
      class="indent"
    >请注意：如果权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果上述个人或单位不确定网络上可获取的资料乙方的软件产品是否侵犯了其知识产权和其他合法权益，乙方建议该个人或单位首先咨询专业人士。</p>
    <p class="indent">为了乙方有效处理上述个人或单位的权利通知，请使用以下格式（包括各条款的序号）：</p>
    <p class="indent">1.权利人对涉嫌侵权内容拥有知识产权或其他合法权益和/或依法可以行使知识产权或其他合法权益的权属证明。</p>
    <p class="indent">2.请充分、明确地描述被侵犯了知识产权或其他合法权益的情况，并指明涉嫌侵权的具体内容。</p>
    <p class="indent">3.请提供权利人具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件。</p>
    <p
      class="indent"
    >4.请在权利通知中加入如下关于通知内容真实性的声明：“我本人/本公司保证，本通知中所述信息是充分、真实、准确的，如果本权利通知内容不完全属实，本人/本公司将承担由此产生的一切法律责任。”请您签署该权利通知，如果您是依法成立的机构或组织，请您加盖公章。</p>
    <h2>十三、其他</h2>
    <p
      class="indent"
    >一方或双方此前就本协议有关事项以口头或书面形式形成的一切性质的许诺、承诺、声明、建议、意见、保证、安排、草案、协议、谅解、备忘录等，凡与本协议有冲突之处，均以本协议约定为准。</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: this.$storage.getUserName()
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/protocol/info")
        .then(response => {
          if (response.code == 0) {
            this.userName = response.data.userName;
          } else if (response.code != 100) {
            this.$global.alertAndWindowClose(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndWindowClose("网络异常，请稍后重试。");
        });
    }
  }
};
</script>

<style scoped>
.wrap {
  width: 750px;
  margin: 0 auto;
}
.agreement {
  padding: 30px;
  color: #505050;
}

.agreement h1 {
  font-size: 21px;
  margin-bottom: 35px;
  text-align: center;
  font-weight: bold;
}

.agreement h2,
.agreement h3 {
  font-size: 18px;
  margin: 40px 0;
  font-weight: bold;
}

.agreement p,
.agreement dl {
  font-size: 18px;
  margin-bottom: 25px;
  line-height: 1.5;
}

.agreement p.indent,
.agreement dl,
.agreement h3 {
  text-indent: 36px;
}
body,
html {
  height: 100%;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/Protocol.vue